import React from 'react';
import { Task } from '../../dto';

export const TaskDetail: React.FC<{ task: Task }> = ({ task }) => {
  return <div>Task {task.id}</div>;
};
